import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './App';

const urlParams = new URLSearchParams(window.location.search);
window.isIos = (urlParams.get("target") === "iOS");
window.isAndroid = (urlParams.get("target") === "android");

window.isMobileApp = (window.isIos || window.isAndroid);


ReactDOM.render(<App />, document.getElementById('root'));

//serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();